import React from "react";
import { Voices } from "../components/Sections";
import PageHero from "../components/PageHero";
import Seo from "../components/seo/Seo";
import JsonLd from "../components/seo/JsonLd";
import { InterestCta, TextLink } from "../components/Bits";
import { Reveal } from "../components/Decorative";
import { ROUTES, breadcrumbs } from "../lib/seo";

export default function VoicesPage() {
  return (
    <>
      <Seo route={ROUTES.voices} />
      <JsonLd data={breadcrumbs([{ name: ROUTES.voices.crumb, path: ROUTES.voices.path }])} />

      <PageHero
        eyebrow="Voices"
        title={<>In their <span className="gold-grad italic">own words</span></>}
        intro="What it feels like from inside the room, told by the people who were singing. New here? See what a bhajan jamming evening actually is."
      >
        <p className="mt-3 font-body text-base" style={{ color: "#E8D9C5" }}>
          <TextLink to={ROUTES.pillar.path}><span style={{ color: "#E5C880" }}>What is bhajan jamming?</span></TextLink>
        </p>
      </PageHero>

      <Voices />

      <section className="bg-cream py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <Reveal>
            <InterestCta note="Come add your voice to the next one." />
          </Reveal>
        </div>
      </section>
    </>
  );
}
